import type { ConcreteMedicalRecord, MedicalRecord, MedicalRecordData, StoredMedicalRecord } from "@qendo/medical";
import { MedicalType } from "@qendo/medical/types";
import { Allergy } from "~/entities/medical/allergy";
import { Condition } from "~/entities/medical/condition";
import { Immunisation } from "~/entities/medical/immunisation";
import { Medication } from "~/entities/medical/medication";
import { PastSymptom } from "~/entities/medical/past_symptom";
import { Supplement } from "~/entities/medical/supplement";
import { Surgery } from "~/entities/medical/surgery";
import { Trigger } from "~/entities/medical/trigger";
import type { DataPayload } from "~/util/data";

function fromRecord<T extends MedicalType = MedicalType>(data: StoredMedicalRecord<T>): ConcreteMedicalRecord<T>;
function fromRecord<T extends MedicalType = MedicalType>(data: MedicalRecordData<T>): MedicalRecord<T> {
    switch (data.type as T) {
        case MedicalType.allergy:
            return Allergy.from(data as DataPayload<Allergy>) as MedicalRecord<T>;
        case MedicalType.condition:
            return Condition.from(data as DataPayload<Condition>) as MedicalRecord<T>;
        case MedicalType.immunisation:
            return Immunisation.from(data as DataPayload<Immunisation>) as MedicalRecord<T>;
        case MedicalType.medication:
            return Medication.from(data as DataPayload<Medication>) as MedicalRecord<T>;
        case MedicalType.past_symptom:
            return PastSymptom.from(data as DataPayload<PastSymptom>) as MedicalRecord<T>;
        case MedicalType.supplement:
            return Supplement.from(data as DataPayload<Supplement>) as MedicalRecord<T>;
        case MedicalType.surgery:
            return Surgery.from(data as DataPayload<Surgery>) as MedicalRecord<T>;
        case MedicalType.trigger:
            return Trigger.from(data as DataPayload<Trigger>) as MedicalRecord<T>;
        default:
            throw Error(`Invalid medical record type`);
    }
}

export { fromRecord };
